import { Staff as PBStaff } from "gen/company/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchStaffs } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"
import { Staff } from "lib/staff"

export function useClerkFilter({
  persistInUrl = true,
  key = "clerk",
  label = "Clerk",
  initialSelectedOptions = [],
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "label" | "initialSelectedOptions"
  >
> = {}) {
  const { results, setQuery, loadNext } = useSearchStaffs()

  const staffs = useMemo(() => {
    const staffs: PBStaff[] = []
    for (const { staff } of results) {
      if (!staff) continue
      staffs.push(staff)
    }
    return staffs
  }, [results])

  const { filter, selected: selectedClerkIds } = useIdFilter({
    key,
    label,
    values: staffs,
    labelExtractor: (staff) => Staff.fromPB(staff).fullName,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedClerkIds }
}
